import { FC, ReactNode } from 'react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';

interface MenuRowContentProps {
  icon: ReactNode;
  trailingIcon?: ReactNode;
  variant?: 'default' | 'destructive';
  children: ReactNode;
}

export const MenuRowContent: FC<MenuRowContentProps> = ({
  icon,
  trailingIcon,
  variant = 'default',
  children,
}) => {
  return (
    <>
      <span
        className={cn(
          'flex shrink-0 items-center justify-center',
          variant === 'destructive'
            ? '**:text-icon-danger-default!'
            : '**:text-icon-primary-default!',
        )}
      >
        {icon}
      </span>
      <span className="flex-1 truncate">{children}</span>
      {trailingIcon && (
        <span className="flex shrink-0 items-center justify-center stext-muted-default">
          {trailingIcon}
        </span>
      )}
    </>
  );
};
